function Hero() {
  return (
    <div
      id="hero-2026"
      className="d-flex align-items-center justify-content-center py-5"
    >
      <div className="container">
        <h4>A 1ª renovação</h4>
        <h1 style={{ fontWeight: "bold" }}>
          Tissy&
          <br />
          Gabriel
        </h1>
        <h2 className="px-2">
          Um ano e meio depois
          <br />
          A mesma escolha
          <br />
          Com mais certeza do que nunca ❤️
        </h2>
      </div>
    </div>
  );
}

export default Hero;
